import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clipboard, FileText } from 'lucide-react';
import { useLanguage } from '../../../hooks/useLanguage';

interface AnalyticsOverviewProps {
    data: {
        totalInspections: number;
        totalQuotes: number;
        conversionRate: number;
        quoteAcceptanceRate: number;
        totalRevenue: number;
        period: string;
    };
}

export const AnalyticsOverview: React.FC<AnalyticsOverviewProps> = ({ data }) => {
    const { t } = useTranslation();
    const { isRTL } = useLanguage();

    const stats = [
        {
            title: t('analytics.overview.inspections'),
            value: data.totalInspections,
            icon: <Clipboard className="h-6 w-6 text-blue-500" />,
            color: 'bg-blue-50 text-blue-700'
        },
        {
            title: t('analytics.overview.quotes'),
            value: data.totalQuotes,
            icon: <FileText className="h-6 w-6 text-purple-500" />,
            color: 'bg-purple-50 text-purple-700'
        }
    ];

    const getPeriodLabel = (period: string): string => {
        switch (period) {
            case 'day':
                return t('analytics.periods.today');
            case 'week':
                return t('analytics.periods.thisWeek');
            case 'month':
                return t('analytics.periods.thisMonth');
            case 'year':
                return t('analytics.periods.thisYear');
            default:
                return '';
        }
    };

    return (
        <div className={`grid grid-cols-1 md:grid-cols-2 gap-6 ${isRTL ? 'rtl' : ''}`}>
            {stats.map((stat, index) => (
                <div key={index} className="bg-white rounded-lg shadow p-6">
                   {/* <div className="flex items-center justify-between mb-4">
                        <div className={`p-3 rounded-full ${stat.color.split(' ')[0]}`}>
                            {stat.icon}
                        </div>
                        <span className="text-xs font-medium text-gray-500 uppercase">
                            {getPeriodLabel(data.period)}
                        </span>
                    </div>*/}
                    <h3 className="text-lg font-medium text-gray-700">{stat.title}</h3>
                    <p className="text-2xl font-bold mt-2">{stat.value.toLocaleString()}</p>
                </div>
            ))}
        </div>
    );
};